module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-9@2x-f20238ccd6ecbff04c15d05861366b56.png";